// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../types/quill1.3.7-table-module.d.ts" />

import { TranslocoService } from "@jsverse/transloco";
import { QuillConfig } from "ngx-quill";
import { defer } from "rxjs";

export function getQuillConfig(translocoService: TranslocoService): QuillConfig {
    return {
        modules: {
            syntax: false,
            blotFormatter: {},
            keyboard: { bindings: { tab: false } },
            table: {
                fullWidth: true,
                operationMenu: {
                    items: {
                        insertColumnLeft: {
                            text: translocoService.translate("dtmUi.quillEditor.table.insertColumnLeftLabel"),
                        },
                        insertColumnRight: {
                            text: translocoService.translate("dtmUi.quillEditor.table.insertColumnRightLabel"),
                        },
                        insertRowTop: {
                            text: translocoService.translate("dtmUi.quillEditor.table.insertRowUpLabel"),
                        },
                        insertRowBottom: {
                            text: translocoService.translate("dtmUi.quillEditor.table.insertRowDownLabel"),
                        },
                        removeCol: {
                            text: translocoService.translate("dtmUi.quillEditor.table.removeColumnLabel"),
                        },
                        removeRow: {
                            text: translocoService.translate("dtmUi.quillEditor.table.removeRowLabel"),
                        },
                        removeTable: {
                            text: translocoService.translate("dtmUi.quillEditor.table.removeTableLabel"),
                        },
                        mergeCell: {
                            text: translocoService.translate("dtmUi.quillEditor.table.mergeCellsLabel"),
                        },
                        splitCell: {
                            text: translocoService.translate("dtmUi.quillEditor.table.splitCellLabel"),
                        },
                        setBackgroundColor: {
                            text: translocoService.translate("dtmUi.quillEditor.table.setBackgroundColorLabel"),
                        },
                        clearBackgroundColor: {
                            text: translocoService.translate("dtmUi.quillEditor.table.clearBackgroundColorLabel"),
                        },
                        setBorderColor: {
                            text: translocoService.translate("dtmUi.quillEditor.table.setBorderColorLabel"),
                        },
                        clearBorderColor: {
                            text: translocoService.translate("dtmUi.quillEditor.table.clearBorderColorLabel"),
                        },
                    },
                    modifyItems: true,
                },
                selection: {
                    primaryColor: "#1477d5", // $legacy-color-secondary-700
                },
            },
        },
        customModules: [
            {
                path: "modules/blotFormatter",
                implementation: defer(() => import("quill-blot-formatter").then((module) => module.default)),
            },
            {
                path: "modules/table",
                implementation: defer(() =>
                    import("quill1.3.7-table-module").then((module) => {
                        // NOTE: rewirteFormats() is needed to fix cooperating lists and tables; fix suggested by table-module author
                        module.rewirteFormats();

                        return module.default;
                    })
                ),
            },
        ],
    };
}
